// extracted by mini-css-extract-plugin
export default {"container":"GY-z","title":"HY-z","link":"IY-z"};